export const EMPTY_LIVE_KIT_ROOM_MESSAGE = "…";
